<template>
  <Card class="residential-template-mutate-role">
    <InputComponent :label="$tc('customermanager', 2)" :sublabel="$t('helpers:roleSalesman')">
      <UserSelect
        :value="salesman"
        @input="setSalesman"
        multiple
        search
        :items="fetchUsers"
        :promise="promise"
        sortable
        :title="$t('selectx', { x: $tc('customermanager', 2).toLowerCase() })"
        class="elder-input__element"
      />
    </InputComponent>
  </Card>
</template>

<script>
import UserApi from '@/api/User'
import { mapActions, mapState } from 'vuex'
import { i18n } from '@/i18n'

import { InputComponent } from 'vue-elder-input'
import UserSelect from '@/components/User/Select/Modal'
import Card from '@/components/Card'

const meta = {
  order: 4,
  id: 'roles',
  label: i18n.tc('role', 2),
  icon: ['fal', 'user'],
}

export { meta }
export default {
  props: {
    id: String,
  },
  data() {
    return {
      promise: null,
    }
  },
  computed: {
    ...mapState('ResidentialTemplate', ['item']),
    salesman() {
      return this.$path('item.roles.salesman') || []
    },
  },
  methods: {
    ...mapActions('ResidentialTemplate', ['mutate']),
    fetchUsers(filter = {}) {
      return UserApi.get({ filter }, { query: 'UserSearch' })
    },
    setSalesman(value) {
      this.item.roles.salesman = value

      this.promise = this.mutate([
        { id: this.id, data: { roles: { salesman: value.map(v => v.id) } } },
        { transformPayload: false, strategy: 'none' },
      ])
    },
  },
  components: {
    InputComponent,
    UserSelect,
    Card,
  },
}
</script>

<style lang="scss">
.residential-template-mutate-role {
  max-width: 800px;

  .elder-input__element {
    max-height: 300px;
    overflow-y: auto;

    @include scrollShadow();
  }
}
</style>
